module.exports = __webpack_public_path__ + "img/20191108155018925.2de39af4.jpg";